import { Button, Dialog, Intent, Shape } from '@axieinfinity/matcha'

type TWalletLinkErrorModalProps = {
  title?: string
  content?: React.ReactNode
  disabled?: boolean
  visible?: boolean
  onClose?: () => void
}

const WalletLinkErrorModal: React.FC<TWalletLinkErrorModalProps> = ({
  visible,
  title,
  content,
  disabled,
  onClose,
}) => {
  return (
    <Dialog
      className="[&_.dango-dialog-content]:bg-surface-color-default [&_.dango-dialog-content]:border [&_.dango-dialog-content]:border-border-color-default [&_.dango-dialog-body]:p-0 [&_.dango-dialog-content]:!p-0 p-16 !w-[390px] sm:!w-[500px]"
      visible={visible}
      onClose={onClose}
      size="small"
    >
      <div className="flex flex-col p-24">
        <div className="mb-12 mt-8 text-h4">{title}</div>
        {content}
        <div className="flex w-full items-center justify-end">
          <Button
            shape={Shape.Default}
            intent={Intent.Primary}
            disabled={disabled}
            onClick={onClose}
            text="Got it"
          />
        </div>
      </div>
    </Dialog>
  )
}

export default WalletLinkErrorModal
